// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3sT6r","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1vyYu"};